import GeoJSON from 'ol/format/GeoJSON';
import {Vector as VectorSource} from 'ol/source';
import {Vector as VectorLayer} from 'ol/layer';
import {Cluster} from 'ol/source';
//var ol = require('ol');
//generates assets by apdzivota vieta
/*
	field,
	style
*/
var dividedAsset = function(optionsIn) {

	this.options = $.extend({
		fullSource: false,
		visible: false,
		zIndexField: false,
	}, optionsIn);
	
	this.assetsGrouped = {};
}

dividedAsset.prototype.generate = function(geojson) {

	var arrAssets = [];

	var featuresGrouped = {};
	for (var i = geojson.features.length - 1; i >= 0; i--) {

		var feature = geojson.features[i];

		var group = feature.properties[this.options.field];
		
		if(group === null) {
			group = 'NONE';
		}

		if(typeof featuresGrouped[group] !== 'undefined') {

			featuresGrouped[group].push(feature);
		} else {

			featuresGrouped[group] = [feature];
		}
	}
	
	this.assetsGrouped = {};
	for(var key in featuresGrouped)
	{
		
		this.assetsGrouped[key] = {};
		this.assetsGrouped[key].sourceClean = new VectorSource({
		  format: new GeoJSON(),
		  features: (new GeoJSON()).readFeatures({type: "FeatureCollection", crs:geojson.crs, features:featuresGrouped[key]})
		});


		//Middle source for filtering active feature groups
		this.assetsGrouped[key].sourceFiltred = new VectorSource({
		});

		if(!this.options.fullSource)
		{
			var sourceForCluster = this.assetsGrouped[key].sourceFiltred;
		} else {
			var sourceForCluster = this.assetsGrouped[key].sourceClean;
		}

		//Default cluster source
		this.assetsGrouped[key].source = new Cluster({
			distance: 85,
			source:sourceForCluster
		});

		//Default cluster source
		this.assetsGrouped[key].sourceCluserMin = new Cluster({
			distance: 10,
			source:sourceForCluster
		});
		

		this.assetsGrouped[key].sourceClusterFull = new Cluster({
			distance: 50000,
			source:sourceForCluster
		});
		
		this.assetsGrouped[key].layer = new VectorLayer({ //
			group: (this.options.group_id ? this.options.group_id : 'default'),
			source: this.assetsGrouped[key].source,
			style: this.options.style,
			visible: this.options.visible,
			zIndex: 70
		//	updateWhileAnimating: true //enable for lag
		});
	//	this.assetsGrouped[feature.properties[this.field]] = [];
		
	}

}

dividedAsset.prototype.getAssets = function() {

	return this.assetsGrouped;
}

dividedAsset.prototype.getLayers = function() {

	var layers = [];

	for(var key in this.assetsGrouped) {

		if (!this.assetsGrouped.hasOwnProperty(key)) {
			continue;
		}

		layers.push(this.assetsGrouped[key].layer);
	}

	return layers;
}

//sets geojson source directly to cluster source without "filter" source
dividedAsset.prototype.setFullSource = function() {
	//WIP
	for(var key in this.assetsGrouped)
	{
		var asset = this.assetsGrouped[key];

	//	asset.sourceClusterFull.setSource(asset.sourceClean);
	}
}

dividedAsset.prototype.loopAllFeatures = function(callback){

	for(var key in this.assetsGrouped) {

		if (!this.assetsGrouped.hasOwnProperty(key)) {
			continue;
		}

		this.assetsGrouped[key].sourceClean.forEachFeature(callback);
	}
}

dividedAsset.prototype.setVisible = function(bolVis){

	for(var key in this.assetsGrouped) {

		if (!this.assetsGrouped.hasOwnProperty(key)) {
			continue;
		}

		this.assetsGrouped[key].layer.setVisible(bolVis);
	}

	return this;
}

module.exports = dividedAsset;




// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/dividedAsset/dividedAsset.js